import { useEffect, useState } from "react";
import Vector from "../Assets/Images/Welcome.png";
import Cursor from "../Assets/Images/cursor-left.svg";
import MobileHeaderImage from "../Assets/Images/Mobile-logo-auth.svg";
import Lady from "../Assets/Images/Success-register.svg";
import X from "../Assets/Icons/x-red.svg";
import Check from "../Assets/Icons/tick-dark.svg";
import {
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Checkbox,
  FormControlLabel,
  useMediaQuery,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import X_Circle from "../Assets/Icons/x-circle.svg";
import { Link as RouterLink, Link } from "react-router-dom";
import Collapsible from "react-collapsible";
import axios from "axios";
import WeddinglyLogo from "../Assets/Images/logo-auth.svg";
import useTnC from "../Hooks/useTnC";
import GoogleAuthButton from "../Components/GoogleAuthButton";
import TncText from "../Components/TncText";
import Divider from "../Components/Divider";

const Signup = () => {
  const { tncHTML } = useTnC();

  useEffect(() => {
    // Dynamically load the reCAPTCHA script
    const script = document.createElement("script");
    script.src =
      "https://www.google.com/recaptcha/api.js?render=6LemYw0qAAAAAPkmgvUN-XqqxnJZlBfXbCCU9A1l";
    script.async = true;
    script.defer = true;
    script.id = "recaptcha-script";
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, []);
  const isMobile = useMediaQuery("(max-width: 960px)"); // Detect if the screen is mobile

  const [Name, setName] = useState("");
  const [Email, setEmail] = useState("");
  const [Password, setPassword] = useState("");
  const [ShowPassword, setShowPassword] = useState(false);
  const [PasswordRepeat, setPasswordRepeat] = useState("");
  const [TermsAccepted, setTermsAccepted] = useState(false);
  const [ShowPasswordRepeat, setShowPasswordRepeat] = useState(false);
  const [TermsIsOpen, setTermsIsOpen] = useState(false);
  const [EmailValidation, setEmailValidation] = useState({
    hasError: false,
    errorMessage: "",
  });
  const [PasswordValidation, setPasswordValidation] = useState({
    hasError: false,
    errorMessage: "",
  });
  const [PasswordRepeatValidation, setPasswordRepeatValidation] = useState({
    hasError: false,
    errorMessage: "",
  });
  const [NameValidation, setNameValidation] = useState({
    hasError: false,
    errorMessage: "",
  });
  const [SignupIsDone, setSignupIsDone] = useState(false);

  const handleTermsAcceptedChange = (event) => {
    setTermsAccepted(event.target.checked);
  };

  const handleNameChange = (event) => {
    setName(event.target.value);
    setNameValidation({ hasError: false, errorMessage: "" });
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);
    setEmailValidation({ hasError: false, errorMessage: "" });
  };

  const handlePasswordChange = (event) => {
    setPassword(event.target.value);
    setPasswordValidation({ hasError: false, errorMessage: "" });
  };

  const handlePasswordRepeatChange = (event) => {
    setPasswordRepeat(event.target.value);
    setPasswordRepeatValidation({ hasError: false, errorMessage: "" });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Handle form submission logic
  };

  const handleShowPassword = () => {
    setShowPassword(!ShowPassword);
  };

  const handleShowPasswordRepeat = () => {
    setShowPasswordRepeat(!ShowPasswordRepeat);
  };

  const handleClearEmail = () => {
    setEmail("");
    setEmailValidation({ hasError: false, errorMessage: "" });
  };

  const handleClearName = () => {
    setName("");
    setNameValidation({ hasError: false, errorMessage: "" });
  };

  const entriesPassValidation = () => {
    if (
      Name.length > 0 &&
      Email.length > 0 &&
      Password.length > 0 &&
      PasswordRepeat.length > 0 &&
      Password.length >= 8 &&
      /[A-Z]/.test(Password) &&
      /\d/.test(Password) &&
      TermsAccepted &&
      /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(Password)
    ) {
      return true;
    } else {
      return false;
    }
  };

  const validateRegisterEntries = () => {
    let EmailRegEx = /^[\w.+-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
    if (!EmailRegEx.test(Email)) {
      setEmailValidation({
        hasError: true,
        errorMessage: "Please enter a valid email address.",
      });
    } else if (Password !== PasswordRepeat) {
      // setPasswordValidation({
      //   hasError: true,
      //   errorMessage: "Password and repeat password do not match.",
      // });
      setPasswordRepeatValidation({
        hasError: true,
        errorMessage: "Passwords do not match.",
      });
    } else {
      toggleRegister();
    }
  };

  const toggleRegister = async () => {
    const token = await window.grecaptcha.execute(
      "6LemYw0qAAAAAPkmgvUN-XqqxnJZlBfXbCCU9A1l",
      { action: "signup" }
    );

    let Req = {
      method: "POST",
      baseURL: window.localStorage.getItem("BaseURL") + "/api/register",
      headers: {
        "Content-Type": "application/json",
        "recaptcha-token": token,
      },
      data: {
        fullName: Name,
        email: Email,
        password: Password,
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        if (Res.status === 201) {
          setSignupIsDone(true);
        }
      })
      .catch((Err) => {
        console.log(Err);
        if (Err.response.data.message === "error.emailexists") {
          setEmailValidation({
            hasError: true,
            errorMessage: "A user with this email already exists.",
          });
        }
      });
  };

  const inputClasses = {
    "& .MuiOutlinedInput-root": {
      borderRadius: isMobile ? "4px 4px 0 0" : "15px",
      backgroundColor: isMobile ? "#F3EEE6" : "#fff1f2",
      border: "none",
      transition: "background-color 0.3s ease-in-out", // Smooth transition for background
      minWidth: "90% !important", // Updated
      maxWidth: "500px !important", // Updated
      width: "100%",
      fontSize: "20px",
      fontWeight: "600",
      paddingLeft: "10px",
      color: "#171717",
    },

    "& .MuiOutlinedInput-root.Mui-focused": {
      backgroundColor: "#f8e0e0", // Change background on focus
    },

    "& .MuiOutlinedInput-notchedOutline": {
      border: "none !important", // Remove outline border
    },

    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: "none !important",
    },

    "& .MuiInputBase-input::placeholder": {
      color: "#1717174D", // Default placeholder color
      transition: "color 0.3s ease-in-out, opacity 0.3s ease-in-out", // Smooth placeholder animation
    },

    "& .MuiInputBase-input:focus::placeholder": {
      color: "#9e7676",
      opacity: 0.9,
    },
  };

  return (
    <main className="auth-wrapper">
      <section className="auth-left-wrapper">
        <div className="auth-vector-container">
          <img className="auth-vector" alt="welcome" src={Vector} />
        </div>
        <img
          src={WeddinglyLogo}
          alt="weddingly logo"
          className="auth-weddingly-logo"
        />
      </section>
      {TermsIsOpen ? (
        <section className="auth-right-wrapper">
          {!isMobile ? (
            <div className="section-head-action">
              <Link onClick={() => setTermsIsOpen(false)} variant="body2 ">
                <img alt="" src={Cursor} />
                <p>Back to the sign-up page</p>
              </Link>
            </div>
          ) : null}
          <form
            className="auth-form big-form"
            style={
              !isMobile
                ? {
                    minWidth: "80%",
                  }
                : {}
            }
            onSubmit={null}
          >
            <p className="form-head-text form-head-text-small">
              Terms, Payment and Data Privacy
            </p>
            <div
              className="terms-text-wrapper  mobile-terms-wrapper"
              dangerouslySetInnerHTML={{ __html: tncHTML }}
            ></div>
          </form>
          <span className="back-btn" onClick={() => setTermsIsOpen(false)}>
            {isMobile ? "Close" : "Back to sign up"}
          </span>
        </section>
      ) : (
        <section className="auth-right-wrapper">
          {!isMobile ? (
            <div className="section-head-action">
              <Link to="/" variant="body2 ">
                <img alt="" src={Cursor} />
                <p>Back to the login page</p>
              </Link>
            </div>
          ) : null}
          <img
            alt=""
            className="is-mobile mobile-header-image"
            src={MobileHeaderImage}
          />
          {SignupIsDone ? (
            <div className="auth-form">
              <h1 className="signup-success-text">Welcome to Weddingly.ai</h1>
              <img className="signup-success-image" alt="" src={Lady} />
              <span className="signup-success-info">
                <p>
                  Please&nbsp;
                  <span className="highlight">
                    check your inbox for an email
                  </span>
                  &nbsp; to activate your account. If you don't see it, make
                  sure to&nbsp;
                  <span className="highlight">
                    check your Junk/Spam folder.
                  </span>
                </p>
              </span>
            </div>
          ) : (
            <form className="auth-form" onSubmit={handleSubmit}>
              <p className="form-head-text form-head-text-small">
                Let’s get started and create your account
              </p>
              <TextField
                autoComplete="off" // Disable autofill
                fullWidth
                id="name"
                name="name"
                placeholder={isMobile ? "Name" : "Name"}
                variant="outlined"
                value={Name}
                onChange={handleNameChange}
                error={NameValidation.hasError}
                helperText={NameValidation.errorMessage}
                margin="normal"
                sx={inputClasses}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {Name && ( // Render clear button only if username has value
                        <IconButton
                          aria-label="clear username"
                          onClick={handleClearName}
                          edge="end"
                          style={{ color: "#171717" }}
                        >
                          <img alt="x" src={X_Circle} />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                autoComplete="off" // Disable autofill
                fullWidth
                id="email"
                name="weddingly-username"
                placeholder={isMobile ? "Email" : "Email"}
                variant="outlined"
                value={Email}
                onChange={handleEmailChange}
                error={EmailValidation.hasError}
                helperText={EmailValidation.errorMessage}
                margin="normal"
                sx={inputClasses}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {Email && ( // Render clear button only if username has value
                        <IconButton
                          aria-label="clear username"
                          onClick={handleClearEmail}
                          edge="end"
                          style={{ color: "#171717" }}
                        >
                          <img alt="x" src={X_Circle} />
                        </IconButton>
                      )}
                    </InputAdornment>
                  ),
                }}
              />

              <Collapsible
                trigger={
                  <TextField
                    autoComplete="new-password" // Disable autofill
                    fullWidth
                    name="weddingly-password"
                    id="password"
                    placeholder={isMobile ? "Password" : "Password"}
                    type={ShowPassword ? "text" : "password"}
                    variant="outlined"
                    value={Password}
                    onChange={handlePasswordChange}
                    error={PasswordValidation.hasError}
                    helperText={PasswordValidation.errorMessage}
                    margin="normal"
                    sx={{
                      ...inputClasses,
                      "& input[type='password']": {
                        ...(Password.length && {
                          fontFamily: "Verdana",
                          letterSpacing: "2px",
                        }),
                      },
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleShowPassword}
                            edge="end"
                            style={{ color: "#171717" }}
                          >
                            {ShowPassword ? <VisibilityOff /> : <Visibility />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                }
              >
                <div className="password-validation-wrapper">
                  <section
                    className={
                      Password.length >= 8
                        ? "validation-row"
                        : "validation-row validation-row-error"
                    }
                  >
                    <img alt="" src={Password.length >= 8 ? Check : X} />
                    At least 8 characters
                  </section>
                  <section
                    className={
                      /[A-Z]/.test(Password)
                        ? "validation-row"
                        : "validation-row validation-row-error"
                    }
                  >
                    <img alt="" src={!/[A-Z]/.test(Password) ? X : Check} />
                    At least one capital letter
                  </section>
                  <section
                    className={
                      /\d/.test(Password)
                        ? "validation-row"
                        : "validation-row validation-row-error"
                    }
                  >
                    <img alt="" src={!/\d/.test(Password) ? X : Check} />
                    At least one digit
                  </section>
                  <section
                    className={
                      /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(Password)
                        ? "validation-row"
                        : "validation-row validation-row-error"
                    }
                  >
                    <img
                      alt=""
                      src={
                        !/[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(Password)
                          ? X
                          : Check
                      }
                    />
                    At least one special character
                  </section>
                </div>
              </Collapsible>
              <TextField
                autoComplete="new-password" // Disable autofill
                fullWidth
                name="repeat-password"
                id="repeat-"
                placeholder={isMobile ? "Password repeat" : "Password repeat"}
                type={ShowPasswordRepeat ? "text" : "password"}
                variant="outlined"
                value={PasswordRepeat}
                onChange={handlePasswordRepeatChange}
                error={PasswordRepeatValidation.hasError}
                helperText={PasswordRepeatValidation.errorMessage}
                margin="normal"
                sx={{
                  ...inputClasses,
                  "& input[type='password']": {
                    ...(PasswordRepeat.length && {
                      fontFamily: "Verdana",
                      letterSpacing: "2px",
                    }),
                  },
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleShowPasswordRepeat}
                        edge="end"
                        style={{ color: "#171717" }}
                      >
                        {ShowPasswordRepeat ? (
                          <VisibilityOff />
                        ) : (
                          <Visibility />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <section className="form-links form-links-flexed">
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={TermsAccepted}
                      onChange={handleTermsAcceptedChange}
                      color="primary"
                      sx={{
                        "&.Mui-checked": {
                          color: "#171717", // Change color to purple when checked
                        },
                        marginRight: "-8px", // Reduce top margin
                      }}
                    />
                  }
                />
                <p>Accept</p>
                <p
                  className="modal-trigger"
                  onClick={() => setTermsIsOpen(true)}
                  style={{ color: "#fb4764" }}
                >
                  Terms & Conditions
                </p>
              </section>

              <Button
                type="submit"
                variant="contained"
                onClick={() => validateRegisterEntries()}
                disabled={entriesPassValidation() ? false : true}
                sx={{
                  backgroundColor: isMobile ? "#F8FAE5" : "#FB4764",
                  "&:hover": {
                    backgroundColor: isMobile ? "#F8FAE5" : "#FB4764",
                  },
                  "&.Mui-disabled": {
                    color: "#B4A9A9",
                  },
                  height: isMobile ? "36px" : "56px",
                  fontSize: "25px",
                  fontWeight: "400",
                  display: "flex",
                  color: isMobile ? "#292D32" : "#ffff",
                  boxShadow: isMobile ? "none" : "",
                  marginTop: isMobile ? "16px" : "10px",
                  gridGap: "8px",
                  textTransform: "none", // Prevent text from being all caps,
                  borderRadius: "15px",
                  fontFamily: "Inter, sans-serif",
                }}
              >
                Create account
              </Button>
              <section className="form-links form-links-flexed">
                <p>Have an account?</p>
                <Link
                  component={RouterLink}
                  to="/"
                  variant="body2"
                  sx={{ marginTop: "10px", display: "block" }}
                >
                  Login here
                </Link>
              </section>

              <Divider />
              <GoogleAuthButton text="Sign up with Google" />
              <div style={{ marginTop: "20px" }}>
                <TncText onClick={() => setTermsIsOpen(true)} />
              </div>
            </form>
          )}
        </section>
      )}
    </main>
  );
};

export default Signup;
